// Constants
import { ProductState, ReturnFields } from "constants/gpoSearchEnum";

// Types
import { Category } from "interfaces/category";
import { FiltersInterface } from "interfaces/osaSearch";
import { QueryString } from "interfaces/queryString";

// Utils
import { buildGpoSearchSortPagingProductPerPageSearchQuery, matchFilterParameters, parsePrimaryKeysQueryString } from "utils/filters";
import { getUrlQueryParams, getUrlWithoutQueryParams } from "utils/queryString";

export const getParameterForOsaQuery = (pathname: string, categories: Category[]) => {
	const urlPath = pathname.includes("?") ? getUrlWithoutQueryParams(pathname) : pathname;
	const splitIndexedFilters = urlPath.split("-");
	const indexedFilters = splitIndexedFilters[splitIndexedFilters.length - 1];
	const selectedCategories = matchFilterParameters(indexedFilters, categories, pathname);
	const gpoFilters: FiltersInterface[] = selectedCategories.map((selectedCategory) => ({
		fieldName: ReturnFields.TAG_ID,
		terms: selectedCategory.selectedTags.flatMap((tag) => tag.id.toString())
	}));
	const primaryKeysQueryString: QueryString[] = parsePrimaryKeysQueryString(getUrlQueryParams(pathname));
	gpoFilters.push({
		fieldName: ReturnFields.PRODUCT_STATE,
		terms: [ProductState.NOTSTARTED_VALID, ProductState.ELEARNING_VALID, ProductState.NOTSTARTED_NOTVALID, ProductState.STARTED_ENDED, ProductState.ELEARNING_NOTVALID]
	});
	const { gpoSorting, paging, productPerPage, querySearch } = buildGpoSearchSortPagingProductPerPageSearchQuery(primaryKeysQueryString);
	return {
		querySearch,
		gpoFilters,
		gpoSorting,
		paging,
		productPerPage,
		selectedCategories
	};
};
